module.exports = __webpack_public_path__ + "static/media/witch-staff-1.6d576486.glb";